// Generated by Copilot
import { Classes } from "@blueprintjs/core";
import { useNavigate } from "react-router";

import { RichContentRenderer } from "@/components/helpers/ui/RichContentRenderer";
import {
  buildComponentMetadata,
  isComponentInProgressOrOverdue,
} from "@/components/pages_logged_in/program/components/componentMetadata";
import { ParticipantComponentStatistic } from "@/components/pages_logged_in/program/components/program-component/ParticipantComponentStatistic";
import { canViewComponentStatistic } from "@/components/pages_logged_in/program/components/utils";
import { Button } from "@/components/ui/button";
import { PanelProps } from "@/types/programs";

export function ProgramSurveyItemPanel({
  component,
  program,
  role = "participant",
  view = "list",
}: PanelProps) {
  const { participantGuidance, status } = component || {};
  const isProgramLead = role === "lead";

  const canViewStatistic = canViewComponentStatistic(component, isProgramLead);

  const metaData = buildComponentMetadata({
    component,
    isProgramLead,
  });
  const navigate = useNavigate();

  const takeSurveyContainer = (
    <div className="xs:p-3.5 xs:rounded-md xs:gap-3 flex flex-col bg-gradient-to-br from-[#F2FAFF] to-[#D8ECF8] md:gap-4 md:rounded-lg md:p-6">
      <div className="text-lg font-semibold text-blue-800">
        It's time to take the survey
      </div>
      <div>
        <Button
          className="xs:px-7 xs:py-2.5 md:px-12 md:py-3"
          onClick={() => navigate(`/surveys/${component?.survey?.id}`)}
          variant="solid"
          intent="primary"
        >
          <span className="xs:text-sm font-semibold md:text-base">
            Begin Survey
          </span>
        </Button>
      </div>
    </div>
  );

  if (view === "feed") {
    return takeSurveyContainer;
  }

  return (
    <div className="xs:gap-3.5 flex flex-col md:gap-4 empty:hidden">
      {isComponentInProgressOrOverdue(status) &&
        !isProgramLead &&
        metaData.isEligible &&
        takeSurveyContainer}

      {canViewStatistic && (
        <ParticipantComponentStatistic
          component={component}
          program={program}
          isProgramLead={isProgramLead}
        />
      )}

      {status !== "Completed" && !canViewStatistic && !!participantGuidance && (
        <div className="flex flex-col gap-2">
          <div className="text-subtext text-xs font-semibold">
            {metaData.isSurvey ? "GUIDANCE" : ""}
          </div>
          <div className={Classes.RUNNING_TEXT}>
            <RichContentRenderer content={participantGuidance} />
          </div>
        </div>
      )}
    </div>
  );
}
